/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { RouteRecordRaw } from "vue-router";
import AdminSidebar from "../views/admin/Sidebar.vue";

export const AdminRoutes = [
  {
    path: "/admin",
    redirect: "/admin/dashboard"
  },
  {
    path: "/admin/dashboard",
    name: "Admin",
    components: {
      default: () => import(/* webpackChunkName: "admin" */ "../views/admin/Dashboard.vue"),
      sidenav: AdminSidebar,
    },
  },
  {
    path: "/admin/users",
    name: "Users",
    components: {
      default: () => import(/* webpackChunkName: "admin" */ "../views/admin/Users.vue"),
      sidenav: AdminSidebar,
    },
  },
  {
    path: "/admin/users/:userId",
    name: "User",
    components: {
      default: () => import(/* webpackChunkName: "admin" */ "../views/admin/User.vue"),
      sidenav: AdminSidebar,
    },
  },
  {
    path: "/admin/groups",
    name: "Groups",
    components: {
      default: () => import(/* webpackChunkName: "admin" */ "../views/admin/Groups.vue"),
      sidenav: AdminSidebar,
    },
  }, {
    path: "/admin/groups/:groupId",
    name: "Group",
    components: {
      default: () => import(/* webpackChunkName: "admin" */ "../views/admin/Group.vue"),
      sidenav: AdminSidebar,
    },
  }, {
    path: "/admin/chatbots",
    name: "Chatbots",
    components: {
      default: () => import(/* webpackChunkName: "admin" */ "../views/admin/Chatbots.vue"),
      sidenav: AdminSidebar,
    },
  }, {
    path: "/admin/billing",
    name: "Abrechnung",
    components: {
      default: () => import(/* webpackChunkName: "admin" */ "../views/admin/Billing.vue"),
      sidenav: AdminSidebar,
    },
    children: [{
      name: "AdminBillingOverview",
      path: "",
      component: () => import(/* webpackChunkName: "admin" */ "../views/admin/BillingOverview.vue"),
    }, {
      name: "AdminBillingEstimate",
      path: "estimate",
      component: () => import(/* webpackChunkName: "admin" */ "../views/admin/BillingEstimate.vue"),
    }, {
      name: "AdminBillingInvoices",
      path: "invoices",
      component: () => import(/* webpackChunkName: "admin" */ "../views/admin/BillingInvoices.vue"),
    }, {
      name: "AdminBillingPayment",
      path: "payment",
      component: () => import(/* webpackChunkName: "admin" */ "../views/admin/BillingPayment.vue"),
    }, {
      name: "AdminBillingSubscription",
      path: "subscription",
      component: () => import(/* webpackChunkName: "admin" */ "../views/admin/BillingSubscription.vue"),
    }]
  },
] as RouteRecordRaw[];